import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ProjectChecklistService } from '@catmodules/models/project-checklist/services/project-checklist.service';
import { UIBaseModule } from '@catui/ui-base.module';
import { UIFormModule } from '@catuiform/ui-form.module';
import { ButtonModule, DataTableModule } from 'primeng/primeng';
import { ProjectChecklistComponent } from './components/project-checklist/project-checklist.component';
import { DialogModule } from "primeng/primeng";

@NgModule({
  imports: [
    CommonModule,
    DataTableModule,
    UIBaseModule,
    UIFormModule,
    ButtonModule,
    DialogModule
  ],
  declarations: [ProjectChecklistComponent],
  providers: [ProjectChecklistService],
})
export class ProjectChecklistModule { }



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/project-checklist/project-checklist.module.ts